
import * as Highcharts from "highcharts"

declare module "highcharts" {
  export interface Series {
    searchPoint(e: Highcharts.PointerEventObject, compareX?: boolean): (Point|undefined);
  }

  export interface Point {
    y?: number | undefined;
    highlight (event: Highcharts.PointerEventObject): void;
  }
}

// https://www.highcharts.com/forum/viewtopic.php?t=41980
Highcharts.Point.prototype.highlight = function (event) {
  const pointer_event = this.series.chart.pointer.normalize(event)
  this.onMouseOver(event)
  this.series.chart.tooltip.refresh(this)
  this.series.chart.xAxis[0].drawCrosshair(pointer_event, this)
}

export default Highcharts
